<template>
  <div :class="[ns.e('grid')]" :style="gridStyle">
    <template v-for="row in rows" :key="row">
      <div :data-row="row" :class="[ns.e('grid-row')]" :style="gridRowStyle">
        <template v-for="col in cols" :key="col">
          <div
            :data-col="col"
            :class="[ns.e('grid-col')]"
            :style="gridColStyle"
          >
            <div :class="[ns.e('grid-item')]" :style="gridItemStyle" />
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useNamespace } from '@element-plus/hooks'
import { skeletonGridProps } from './skeleton-grid'

defineOptions({
  name: 'ElSkeletonGrid',
})
const props = defineProps(skeletonGridProps)
const ns = useNamespace('skeleton')

const colGutter = computed<number>(() => {
  const gutter: any = Array.isArray(props.gutter)
    ? props.gutter[1] || props.gutter[0] || 16
    : props.gutter
  return Number.parseInt(gutter, 10)
})

const rowGutter = computed<number>(() => {
  const gutter: any = Array.isArray(props.gutter)
    ? props.gutter[0] || props.gutter[1] || 16
    : props.gutter
  return Number.parseInt(gutter, 10)
})

const gridItemStyle = computed<any>(() => ({
  height: `${props.itemHeight}px`,
}))

const gridColStyle = computed<any>(() => ({
  padding: `0 ${colGutter.value / 2}px`,
}))

const gridRowStyle = computed<any>(() => ({
  padding: `${rowGutter.value / 2}px 0`,
  margin: `0 -${colGutter.value / 2}px`,
}))

const gridStyle = computed<any>(() => ({
  margin: `-${rowGutter.value / 2}px 0`,
}))
</script>
